module.exports = __webpack_public_path__ + "themes/fq/font/proximasoft-bold-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./themes/fq/font/proximasoft-bold-webfont.ttf
// module id = 91
// module chunks = d-game